<section class="intro-single">
  <div class="container">
    <div class="row">
      <div class="col-md-12 col-lg-8">
        <div class="title-single-box">
          <h1 class="title-single">Contáctanos</h1>
          <span class="color-text-a">Llena este formulario y nos pondremos en contacto contigo a la brevedad.</span>
        </div>
      </div>
      <div class="col-md-12 col-lg-4">
        <nav aria-label="breadcrumb" class="breadcrumb-box d-flex justify-content-lg-end">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <a [routerLink]="['/app/inicio']">Inicio</a>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
              Contacto
            </li>
          </ol>
        </nav>
      </div>
    </div>
  </div>
</section>





<section class="contact">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div class="row">
          <div class="col-md-7">
            <form #contactoForm="ngForm" (ngSubmit)="enviar_mensaje(contactoForm)" class="form-a contactForm" aria-describedby="contact-status">
              <div class="row">
                <div class="col-md-6 mb-3">
                  <div class="form-group">
                    <label class="contact-label" for="contact-name">Nombre <span aria-hidden="true">*</span></label>
                    <input id="contact-name" type="text" name="nombres" required [(ngModel)]="mensaje.nombres" #nombres="ngModel" class="form-control form-control-lg form-control-a" placeholder="Tu nombre" [attr.aria-invalid]="nombres.invalid && (nombres.touched || formularioIntentado)" [attr.aria-describedby]="nombres.invalid && (nombres.touched || formularioIntentado) ? 'contact-name-error' : null">
                    <div id="contact-name-error" class="invalid-feedback" *ngIf="nombres.invalid && (nombres.touched || formularioIntentado)">Ingresa tu nombre.</div>

                  </div>
                </div>
                <div class="col-md-6 mb-3">
                  <div class="form-group">
                    <label class="contact-label" for="contact-email">Correo electrónico <span aria-hidden="true">*</span></label>
                    <input id="contact-email" name="email" type="email" required [(ngModel)]="mensaje.email" #email="ngModel" class="form-control form-control-lg form-control-a" pattern="^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$" placeholder="Tu email" [attr.aria-invalid]="email.invalid && (email.touched || formularioIntentado)" [attr.aria-describedby]="email.invalid && (email.touched || formularioIntentado) ? 'contact-email-error' : null">
                    <div id="contact-email-error" class="invalid-feedback" *ngIf="email.invalid && (email.touched || formularioIntentado)">Ingresa un correo electrónico válido.</div>

                  </div>
                </div>
                <div class="col-md-6 mb-3">
                  <div class="form-group">
                    <label class="contact-label" for="contact-subject">Asunto <span aria-hidden="true">*</span></label>
                    <input id="contact-subject" type="text" name="asunto" required [(ngModel)]="mensaje.asunto" #asunto="ngModel" class="form-control form-control-lg form-control-a" placeholder="Asunto" [attr.aria-invalid]="asunto.invalid && (asunto.touched || formularioIntentado)" [attr.aria-describedby]="asunto.invalid && (asunto.touched || formularioIntentado) ? 'contact-subject-error' : null">
                    <div id="contact-subject-error" class="invalid-feedback" *ngIf="asunto.invalid && (asunto.touched || formularioIntentado)">Ingresa el asunto de tu mensaje.</div>

                  </div>
                </div>
                <div class="col-md-6 mb-3">
                  <div class="form-group">
                    <label class="contact-label" for="contact-phone">Teléfono <span aria-hidden="true">*</span></label>
                    <input id="contact-phone" type="tel" name="telefono" required [(ngModel)]="mensaje.telefono" #telefono="ngModel" class="form-control form-control-lg form-control-a" placeholder="Teléfono" [attr.aria-invalid]="telefono.invalid && (telefono.touched || formularioIntentado)" [attr.aria-describedby]="telefono.invalid && (telefono.touched || formularioIntentado) ? 'contact-phone-error' : null">
                    <div id="contact-phone-error" class="invalid-feedback" *ngIf="telefono.invalid && (telefono.touched || formularioIntentado)">Ingresa un número de teléfono.</div>

                  </div>
                </div>
                <div class="col-md-12 mb-3">
                  <div class="form-group">
                    <label class="contact-label" for="contact-message">Mensaje <span aria-hidden="true">*</span></label>
                    <textarea id="contact-message" required class="form-control" [(ngModel)]="mensaje.mensaje" #contenido="ngModel" name="mensaje" cols="45" rows="8" placeholder="Mensaje" [attr.aria-invalid]="contenido.invalid && (contenido.touched || formularioIntentado)" [attr.aria-describedby]="contenido.invalid && (contenido.touched || formularioIntentado) ? 'contact-message-error' : null"></textarea>
                    <div id="contact-message-error" class="invalid-feedback" *ngIf="contenido.invalid && (contenido.touched || formularioIntentado)">Escribe el mensaje que deseas enviarnos.</div>

                  </div>
                </div>
                <div class="col-md-12">
                  <button type="submit" class="btn btn-a" [disabled]="enviando">{{ enviando ? 'Enviando...' : 'Enviar mensaje' }}</button>
                  <p id="contact-status" class="form-text" role="status" aria-live="polite" *ngIf="estadoFormulario">{{ estadoFormulario }}</p>
                </div>
              </div>
            </form>
          </div>
          <div class="col-md-5 section-md-t1">
            <div class="icon-box section-b2">
              <div class="icon-box-icon">
                <span class="ion-ios-paper-plane"></span>
              </div>
              <div class="icon-box-content table-cell">
                <div class="icon-box-title">
                  <h4 class="icon-title">Envíanos un mensaje</h4>
                </div>
                <div class="icon-box-content">
                  <p class="mb-1">Email
                    <span class="color-a">contacto@vabait.co</span>
                  </p>
                  <p class="mb-1">Teléfono
                    <span class="color-a">+57 321 846 5585</span>
                  </p>
                </div>
              </div>
            </div>
            <div class="icon-box">
              <div class="icon-box-icon">
                <span class="ion-ios-redo"></span>
              </div>
              <div class="icon-box-content table-cell">
                <div class="icon-box-title">
                  <h4 class="icon-title">Redes sociales</h4>
                </div>
                <div class="icon-box-content">
                  <div class="socials-footer">
                    <ul class="list-inline">
                      <li class="list-inline-item">
                        <a class="ms-3" href="https://wa.me/573218465585"><img src="assets/images/whatsapp.png" alt="logo whatsapp" class="logo-vabait"></a><!-- <i class="fa fa-whatsapp"></i> -->
                      </li>
                      <li class="list-inline-item">
                        <a class="ms-3" href="https://www.instagram.com/vabaitinmobiliaria/"><img src="assets/images/instagram.png" alt="Instagram" class="logo-vabait"></a><!-- <i class="fa fa-whatsapp"></i> -->
                      </li>

                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="intro-single">
  <div class="container">
    <div class="row">
      <div class="col-md-12 col-lg-8">
        <div class="title-single-box">
          <h2 class="title-single">¿Deseas arrendar con nosotros?</h2>
          <span class="color-text-a">Si deseas arrendar con nosotros debes hacer el estudio de crédito, aquí te damos las opciones para que lo realices fácil, rápido y COMPLETAMENTE GRATIS</span>
        </div>
      </div>
      <div class="col-md-12 col-lg-4">
      </div>
    </div>
  </div>
</section>

<section class="contact">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div class="row">
          <div class="col-md-5">
            <button type="button" class="btn btn-a" onclick="window.open('https://analisisweb.ellibertador.co/analisis-persona-natural/arrendatario', '_blank')">Persona Natural</button>
          </div>
          <div class="col-md-5">
            <button type="button" class="btn btn-a" onclick="window.open('https://analisisweb.ellibertador.co/analisis-persona-natural/arrendatario-juridico', '_blank')">Persona Jurídica</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
